import React from 'react';
import { useTranslation } from 'react-i18next';
import { TypeOffre } from '../../../hooks';
import { Typography, Variant } from '../../../styles';

interface TitreCaracteristiquesProps {
    typeOffre: TypeOffre;
    cssClasse: string;
}

export const TitreCaracteristiques: React.FC<TitreCaracteristiquesProps> = ({
    typeOffre,
    cssClasse
}) => {
    const [t] = useTranslation(['DetailsOffreModal']);

    switch (typeOffre) {
        case TypeOffre.UN_ANS_FIXE_FERME:
        case TypeOffre.DEUX_ANS_FIXE_FERME:
        case TypeOffre.TRENTE_MOIS_FIXE_FERME:
        case TypeOffre.TROIS_ANS_FIXE_FERME:
        case TypeOffre.SIX_MOIS_FIXE_FERME:
        case TypeOffre.TRENTENEUF_MOIS_FIXE_FERME:
        case TypeOffre.QUARANTE_MOIS_FIXE_FERME:
        case TypeOffre.QUARANTE_DEUX_MOIS_FIXE_FERME:
        case TypeOffre.QUATRE_ANS_FIXE_FERME:
        case TypeOffre.CINQUANTE_CINQ_MOIS_FIXE_FERME:
        case TypeOffre.CINQ_ANS_FIXE_FERME:
        case TypeOffre.SIX_ANS_FIXE_FERME:
        case TypeOffre.SEPT_ANS_FIXE_FERME:
        case TypeOffre.DIX_ANS_FIXE_FERME:
            return (
                <Typography className={cssClasse} variant={Variant.h3}>
                    {t('titreSectionCaracteristique')}
                </Typography>
            );
        case TypeOffre.CINQ_ANS_VARIABLE_REDUIT:
        case TypeOffre.CINQ_ANS_VARIABLE_PROTEGE:
        case TypeOffre.CINQ_ANS_REVISABLE_FERME:
            return (
                <Typography className={cssClasse} variant={Variant.h3}>
                    {t('titreSectionCaracteristiques')}
                </Typography>
            );
        default:
            return <></>;
    }
};

interface TextCarateristiqueProps {
    typeOffre: TypeOffre;
}

export const TextCarateristique: React.FC<TextCarateristiqueProps> = ({
    typeOffre
}) => {
    const [t] = useTranslation(['DetailsOffreModal']);

    switch (typeOffre) {
        case TypeOffre.UN_ANS_FIXE_FERME:
        case TypeOffre.DEUX_ANS_FIXE_FERME:
        case TypeOffre.TRENTE_MOIS_FIXE_FERME:
        case TypeOffre.TROIS_ANS_FIXE_FERME:
        case TypeOffre.SIX_MOIS_FIXE_FERME:
        case TypeOffre.TRENTENEUF_MOIS_FIXE_FERME:
        case TypeOffre.QUARANTE_MOIS_FIXE_FERME:
        case TypeOffre.QUARANTE_DEUX_MOIS_FIXE_FERME:
        case TypeOffre.QUATRE_ANS_FIXE_FERME:
        case TypeOffre.CINQUANTE_CINQ_MOIS_FIXE_FERME:
        case TypeOffre.CINQ_ANS_FIXE_FERME:
        case TypeOffre.SIX_ANS_FIXE_FERME:
        case TypeOffre.SEPT_ANS_FIXE_FERME:
        case TypeOffre.DIX_ANS_FIXE_FERME:
            return (
                <Typography variant={Variant.p}>
                    {t('caracteristiqueAucuneVariation')}
                </Typography>
            );
        case TypeOffre.CINQ_ANS_VARIABLE_REDUIT:
            return (
                <ul>
                    <li>{t('caracteristiquesTauxBaseTauxPreferentiel')}</li>
                    <li>{t('caracteristiquesPossibleVariation')}</li>
                    <li>{t('caracteristiquesConversionTauxFixe')}</li>
                </ul>
            );
        case TypeOffre.CINQ_ANS_VARIABLE_PROTEGE:
            return (
                <ul>
                    <li>{t('caracteristiquesTauxBaseTauxPreferentiel')}</li>
                    <li>{t('caracteristiquesTauxPlafond')}</li>
                    <li>{t('caracteristiquesTauxMaximumFixe')}</li>
                    <li>{t('caracteristiquesPaiementsFixesEtablis')}</li>
                    <li>{t('caracteristiquesConversionTauxVariable')}</li>
                </ul>
            );
        case TypeOffre.CINQ_ANS_REVISABLE_FERME:
            return (
                <ul>
                    <li>{t('caracteristiquesTauxBase1AnFerme')}</li>
                    <li>{t('caracteristiquesTauxPaiementRevises')}</li>
                    <li>{t('caracteristiquesConversionTauxFixe')}</li>
                </ul>
            );
        default:
            return <></>;
    }
};
